module.exports = __webpack_public_path__ + "static/Logo-614096dbc035482dc8a794f03dcee666.png";